<div class="container columnPadding">
  <div class="row">
    <div class="col-12">
      <h4>Billing Info</h4>
    </div>
  </div>
  <div class="col-12">
  <div>
    @if (stripeBilling?.cCLast4) {
      <span style="margin-right:4px;">{{stripeBilling.cCBrand}} Ending in {{getLast4Display(stripeBilling.cCLast4)}}</span>
    }
    @if (stripeBilling?.aCHLast4) {
      <span style="margin-right:4px;">{{stripeBilling.bankName}} Ending in {{getLast4Display(stripeBilling.aCHLast4)}}</span>
    }
    <span [class]="hasBillingAddEditPermission() ? 'link' : 'link disabledLink'" (click)="openBillingProfileEntryModal()">{{ stripeBilling ? '[EDIT]' : '[ADD]'}}</span>
  </div>
</div>
</div>
@if (displayBillingProfileEntryModal) {
  <app-billing-profile-entry-modal
    [customer]="customer"
    [stripeBilling]="stripeBilling"
    [display]="displayBillingProfileEntryModal"
    (emitUpdatedStripeCustomerId)="updatedStripeCustomer($event)"
    (emitClose)="closeBillingProfileEntryModal()">
  </app-billing-profile-entry-modal>
}